export default "<div  [ngClass]=\"alertClass\">\n  <div [class]=\"bold===true ? 'bold' : ''\" [innerHTML]=\"title\"></div>\n</div>\n"